import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectListUpdateRequiredReducer(state = initialState.projectListUpdateRequired, action) {
    switch (action.type) {
        case types.LOAD_PROJECTS_SUCCESS:
        case types.LOAD_PROJECTS_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_PROJECT_INCOMING:
        case types.UPDATED_PROJECT_SUCCESS:
        case types.UPDATED_ORGANISATION_INCOMING:
        case types.LOAD_ORGANISATION_SUCCESS:
        case types.UPDATED_SITE_INCOMING:
        case types.LOAD_SITE_SUCCESS:
        case types.UPDATED_PROJECTITEM_INCOMING:
        case types.DELETED_PROJECTITEM_INCOMING:    
        case types.LOAD_PROJECTITEM_SUCCESS:  
        case types.DELETED_PROJECTITEM:
        case types.UPDATED_PROJECTITEMINVOICEAMOUNT_INCOMING:
        case types.DELETED_PROJECTITEMINVOICEAMOUNT_INCOMING:
        case types.LOAD_PROJECTITEMINVOICEAMOUNT_SUCCESS:    
        case types.DELETED_PROJECTITEMINVOICEAMOUNT:
        case types.UPDATED_PROJECTITEMNOTE_INCOMING:     
        case types.DELETED_PROJECTITEMNOTE:
        case types.DELETED_PROJECTITEMNOTE_INCOMING:
        case types.CREATED_INVOICE_SUCCESS:
        case types.CREATED_INVOICE_INCOMING:
        case types.DELETED_INVOICE:
        case types.DELETED_INVOICE_INCOMING:
        case types.DELETED_PROJECTITEMACTIVITY_INCOMING:
        case types.DELETED_PROJECTITEMACTIVITY:
        case types.UPDATED_PROJECTITEMACTIVITY_SUCCESS:
        case types.UPDATED_PROJECTITEMACTIVITY_INCOMING:
        case types.UPDATED_PROJECTITEMMILESTONE_SUCCESS:
        case types.DELETED_PROJECTITEMMILESTONE:
        case types.UPDATED_PROJECTITEMMILESTONE_INCOMING:
        case types.DELETED_PROJECTITEMMILESTONE_INCOMING:
        case types.DELETED_PHASENOTE:
        case types.DELETED_PHASENOTE_INCOMING:
        case types.UPDATED_PHASENOTE_INCOMING:
        case types.UPDATED_PHASENOTE_SUCCESS:
            return true;
        default:
            return state;
    }
}